import * as React from 'react'

import { Filter } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'
import { useCollectionFilterQueryParamsContext } from '../../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { ColumnActions } from '../../ColumnActions'
import { useCollectionFiltersContext } from '../../containers/CollectionFiltersContext'
import { ColumnLayoutService } from '../../containers/ColumnLayoutService'
import { FilterModalService } from '../../containers/FilterModalService'
import { textWithFilterCount } from '../../utils'

import {
  ActionButton,
  Actions,
  FilterActions,
  FilterIconWrap,
  FilterLabel,
  TotalWrap,
} from './styles'

export const MobileFilterPanel = () => {
  const { totalItemsCount, filters } = useCollectionFiltersContext()
  const hasFilters = filters && filters.length > 0

  const {
    collections: {
      filtering: { mobileFilterPanel: mobileFilterPanelCopy },
    },
    magnolia: {
      account: { total },
    },
  } = useTranslation()
  const { numberOfColumnsOnMobile, setNumberOfColumnsOnMobile } = ColumnLayoutService.useContainer()
  const { openFilterModal } = FilterModalService.useContainer()

  const { totalNumberOfSelectedFilterValues } = useCollectionFilterQueryParamsContext()

  return (
    <>
      <Actions>
        {hasFilters ? (
          <FilterActions>
            <ActionButton onClick={openFilterModal} variant={'black-on-white'}>
              <FilterIconWrap>
                <Filter />
              </FilterIconWrap>
              <FilterLabel>
                {textWithFilterCount(
                  mobileFilterPanelCopy.filterCta,
                  totalNumberOfSelectedFilterValues
                )}
              </FilterLabel>
            </ActionButton>
          </FilterActions>
        ) : null}
        <TotalWrap>
          {totalItemsCount} {total}
        </TotalWrap>
        <ColumnActions
          numberOfColumnsOnMobile={numberOfColumnsOnMobile}
          setNumberOfColumnsOnMobile={setNumberOfColumnsOnMobile}
        />
      </Actions>
    </>
  )
}
